import React, { useState, useEffect } from "react";
import { API_URL } from "../constants";
import axios from "axios";
import { FaEdit } from "react-icons/fa";
import { UserTypes } from "../constants";

const MachineModel = ({ typeId, token }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const [model, setModel] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [newModel, setNewModel] = useState("");
  const userType = user.type;

  useEffect(() => {
    axios.get(`${API_URL}/typesmachine/${typeId}`, {
      headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${token}` }
    })
      .then(r => { setModel(r.data.modele); setNewModel(r.data.modele); })
      .catch(e => console.error("Erreur modèle :", e.message));
  }, [typeId, token]);

  const handleSaveClick = async () => {
    try {
      const response = await axios.patch(
        `${API_URL}/typesmachine/${typeId}`,
        { modele: newModel },
        { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } }
      );
      if (response.status === 200) { setEditMode(false); setModel(newModel); }
    } catch (error) {
      console.error("Erreur mise à jour modèle", error);
    }
  };

  return (
    <div className="flex flex-col gap-2">
      <span className="text-xs font-semibold text-gray-400 uppercase tracking-wider">Modèle</span>
      {editMode ? (
        <div className="flex flex-col sm:flex-row gap-2">
          <input
            type="text"
            value={newModel}
            onChange={(e) => setNewModel(e.target.value)}
            className="flex-1 border border-gray-200 rounded-xl px-4 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-loginBordure/30 focus:border-loginBordure transition"
          />
          <button onClick={handleSaveClick} className="px-4 py-2 bg-loginBordure hover:bg-blue-900 text-white text-sm font-semibold rounded-xl transition">
            Valider
          </button>
          <button onClick={() => { setEditMode(false); setNewModel(model); }} className="px-4 py-2 bg-red-500 hover:bg-red-700 text-white text-sm font-semibold rounded-xl transition">
            Annuler
          </button>
        </div>
      ) : (
        <div className="flex items-center gap-2">
          <span className="text-sm text-gray-700">{model || <span className="italic text-gray-400">Non renseigné</span>}</span>
          {(userType === UserTypes.SUPER || userType === UserTypes.ADMIN) && (
            <FaEdit className="cursor-pointer text-gray-400 hover:text-loginBordure transition" onClick={() => setEditMode(true)} />
          )}
        </div>
      )}
    </div>
  );
};

export default MachineModel;